import { render, staticRenderFns } from "./Companiesviewed.vue?vue&type=template&id=2c8d9088&scoped=true&"
import script from "./Companiesviewed.vue?vue&type=script&lang=js&"
export * from "./Companiesviewed.vue?vue&type=script&lang=js&"
import style0 from "./Companiesviewed.vue?vue&type=style&index=0&id=2c8d9088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d9088",
  null
  
)

export default component.exports